"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var axios_1 = require("axios");
var wix_axios_config_1 = require("@wix/wix-axios-config");
var EmptyDataError_1 = require("../DealerApi/EmptyDataError");
var BASE_URL = '/_api/wix-dealer-webapp/';
exports.GET_USER_DETAILS_URL = BASE_URL + 'dealerContent';
exports.GET_OFFERS = BASE_URL + 'v1/dealerOffers';
exports.ServerApi = {
    getDealerData: function (params) {
        return exports.ServerApi.doPost(exports.GET_USER_DETAILS_URL, params).then(function (_a) {
            var data = _a.data;
            if (Object.keys(data.dealerData).length === 0) {
                throw new EmptyDataError_1.EmptyDataError();
            }
            return data.dealerData[params.bannerPositions[0]][0];
        });
    },
    getOffersData: function (_a, headers) {
        var _b = _a.excludeAssetIds, excludeAssetIds = _b === void 0 ? [] : _b, realEstateId = _a.realEstateId;
        return exports.ServerApi.doPost(exports.GET_OFFERS, { excludeAssetIds: excludeAssetIds, realEstateId: realEstateId }, headers);
    },
    doPost: function (url, params, headersParams) {
        var instance = wix_axios_config_1.wixAxiosInstanceConfig(axios_1.default, {
            baseURL: '/',
        });
        return instance.post(url, params, {
            headers: tslib_1.__assign({ 'Content-Type': 'application/json;charset=UTF-8' }, headersParams),
        });
    },
};
//# sourceMappingURL=ServerApi.js.map